export const SITE = {
    company: "Shaurya Polymers",
    legal: "Shaurya Polymers Private Limited",
    tagline: "Outdoor Materials, Engineered to Endure",
    estd: "Estd. 2014",
    address: "253/254, Peenya 3rd Phase, 11th Cross, Near TVS Cross Road, Bengaluru – 560058",
    email: "Shaurya.pewicker@gmail.com",
    phone: "+91 99010 43678",
    phoneAlt: "+91 88110 95663",
    nav: [
        { label: "Home", to: "/" },
        { label: "About", to: "/about" },
        { label: "Products", to: "/services" },
        { label: "Contact", to: "/contact" },
    ],
};

export const MEDIA = {
    heroWicker: "https://static.prod-images.emergentagent.com/jobs/70d9859c-1b5b-47a4-ba49-df0c11c679fe/images/06f24a0d7fb348656ef7d4d56b1275ec54a1a7b86f446c35f1b7857e0514e65b.png",
    services: "https://static.prod-images.emergentagent.com/jobs/70d9859c-1b5b-47a4-ba49-df0c11c679fe/images/6982073a4c2cc71ba065153551fa894fc0b09c04b6dfcd8f13b93092945ac164.png",
    ropes: "https://static.prod-images.emergentagent.com/jobs/70d9859c-1b5b-47a4-ba49-df0c11c679fe/images/77beaec1bac81c83e8117add5e960686a84f34e01a8feaf8da86ae84c5cf73e3.png",
    facility: "/about-weaver.jpg",
    team: [
        "https://images.unsplash.com/photo-1758600587839-56ba05596c69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwbmV1dHJhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc3MzY0MzAzfDA&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1770404295179-20767296ad2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwbmV1dHJhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc3MzY0MzAzfDA&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwbmV1dHJhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc3MzY0MzAzfDA&ixlib=rb-4.1.0&q=85",
    ],
};

export const PRODUCTS = [
    {
        id: "pe-wicker",
        name: "PE Wicker",
        kicker: "Synthetic Weave",
        summary: "UV-stable polyethylene wicker in round, flat, half-round, and twisted profiles — engineered for global outdoor furniture brands.",
        bullets: ["UV-resistant up to 2,500 hrs", "Color-fast across seasons", "Round / Flat / Half-round", "200+ standard finishes"],
        image: "https://static.prod-images.emergentagent.com/jobs/70d9859c-1b5b-47a4-ba49-df0c11c679fe/images/06f24a0d7fb348656ef7d4d56b1275ec54a1a7b86f446c35f1b7857e0514e65b.png",
    },
    {
        id: "rattan",
        name: "All-Weather Synthetic Rattan",
        kicker: "Cane & Core",
        summary: "Hand-crafted all-weather synthetic rattan profiles with the warmth of natural cane and the resilience of high-grade polymer — built for sun, rain, and seasons of use.",
        bullets: ["All-weather UV stable construction", "Natural rattan tones", "Hand-finished textures", "Suitable for indoor & outdoor", "Custom widths on request"],
        image: "/synthetic-rattan-furniture.jpg",
    },
    {
        id: "ropes",
        name: "Outdoor Ropes",
        kicker: "Knitted & Braided",
        summary: "PP ropes designed for woven seating, hammocks, and architectural detailing — soft hand, tough core.",
        bullets: ["PP", "Knitted, braided, and flat constructions", "Up to 25mm width"],
        image: "https://static.prod-images.emergentagent.com/jobs/70d9859c-1b5b-47a4-ba49-df0c11c679fe/images/6982073a4c2cc71ba065153551fa894fc0b09c04b6dfcd8f13b93092945ac164.png",
    },
];

export const TEAM = [
    { name: "Akshay Bagri", role: "Managing Director", bio: "Leads Shaurya with two decades of polymer expertise — guiding the company from a single line to a global supplier of outdoor furniture materials.", img: "https://customer-assets.emergentagent.com/job_corporate-web-39/artifacts/figr9cqj_58ABA668-7667-428C-8694-8CE4B1030332.PNG" },
    { name: "Neha Bagri", role: "Head of Operations", bio: "Champions our zero-defect production line, lean manufacturing culture, and the rigorous quality checks behind every roll we ship.", img: MEDIA.team[1] },
];

export const TESTIMONIALS = [
    {
        quote: "Shaurya's PE wicker is the most consistent we've sourced — colour, hand, and gauge are dialled in batch after batch.",
        author: "Procurement Director",
        org: "Global Furniture Brand",
    },
    {
        quote: "Their rope work is something else. We needed a tight spec on width and feel for our hammock line and they nailed it on the first lot.",
        author: "Design Lead",
        org: "Boutique Outdoor Studio",
    },
    {
        quote: "What sets them apart is the conversation. Their team understands weave, drape, and how the material will live in the finished piece.",
        author: "Head of Sourcing",
        org: "Global Hospitality Group",
    },
];
